import React, { useEffect, useRef  } from "react";
import WaveSurfer from "wavesurfer.js";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from 'prop-types';

const waveformCache = new Map();

const getWaveformFromStorage = (audioUrl) => {
  try {
    const data = localStorage.getItem(`waveformCache:${audioUrl}`);
    if (data) {
      return JSON.parse(data);
    }
  } catch (e) {
   console.error("error:",e)
    
  }
  return null;
};
const setWaveformToStorage = (audioUrl, peaks, duration) => {
  try {
    localStorage.setItem(
      `waveformCache:${audioUrl}`,
      JSON.stringify({ peaks, duration })
    );
  } catch (e) {
       console.error("error:",e)
  }
};

const AudioWaveform = ({ audioUrl, height = 120, waveColor = "#FFFFFF", progressColor = "#1976d2" , onWaveformReady, isWaveformLoading=false }) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const getBarConfig = () => {
    if (typeof window === "undefined") {
      return { barWidth: 1, barGap: 1 };
    }
    const width = window.innerWidth || 1920;

    if (width >= 3800) {
      return { barWidth: 3, barGap: 2 };
    }
    if (width >= 2560) {
      return { barWidth: 2.5, barGap: 1.8 };
    }
    if (width >= 1920) {
      return { barWidth: 2, barGap: 1.5 };
    }
    return { barWidth: 1, barGap: 1 };
  };

  const { barWidth, barGap } = getBarConfig();

  useEffect(() => {
    if (!audioUrl || !waveformRef.current) return;

    wavesurfer.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor,
      progressColor,
      height,
      responsive: true,
      barWidth,
      barGap,
      cursorWidth: 1,
      interact: false,
      normalize: true,
      fillParent: true,
      autoCenter: true,
    });

    let cached = getWaveformFromStorage(audioUrl);
    if (!cached) {
      cached = waveformCache.get(audioUrl);
    }
    const handleReady = () => {
      const peaks = wavesurfer.current.exportPeaks();
      console.log("peak",peaks)
      const duration = wavesurfer.current.getDuration();
      waveformCache.set(audioUrl, { peaks, duration });
      setWaveformToStorage(audioUrl, peaks, duration);
      if (onWaveformReady) {
        onWaveformReady();
      }
    };
    if (cached?.peaks && cached?.duration) {
      wavesurfer.current.load(audioUrl, cached.peaks, cached.duration);
       wavesurfer.current.on("ready", () => {
        if (onWaveformReady) {
          onWaveformReady();
        }
      });
    } else {
      wavesurfer.current.load(audioUrl);
      wavesurfer.current.on('ready', handleReady);
    }

    return () => {
      if (wavesurfer?.current) {
        wavesurfer.current.destroy();
      }
    };
  }, [audioUrl, height, waveColor, progressColor]);

  return (
    <div
      style={{
        width: "100%",
        height: `${height}px`,
        position: "relative",
        overflow: "hidden",
        background: "transparent",
      }}
    >
      {isWaveformLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -45%)",
          }}
        >
          <ClipLoader
            color="#FFFFFF"
            isWaveformLoading={true}
            size={32}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
      <div ref={waveformRef} style={{ width: "100%", height: "100%",opacity: isWaveformLoading ? 0 : 1,
          transition: "opacity 0.3s ease",
 }} />
    </div>
  );
};
AudioWaveform.propTypes = {
  audioUrl: PropTypes.string,
  height: PropTypes.number,
  waveColor: PropTypes.string,
  progressColor: PropTypes.string,
  onWaveformReady: PropTypes.func,
  isWaveformLoading: PropTypes.bool
};

export default AudioWaveform;